export interface FirmwareOptionsItem {
    file: string; // file name
    link: string; // file url
    uploadAt: string // upload date string
};